// PLATFORM TIER PRODUCT TYPES
export const IRA = 'IRA';

// FREQUENCY UNITS
export const FREQUENCY_UNIT_MONTH = 'FREQUENCY_UNIT_MONTH';
export const FREQUENCY_UNIT_YEAR = 'FREQUENCY_UNIT_YEAR';

// CONTENT USER TIER TYPES
export const GROWTH_WITH_CONTENT = 'GROWTH_WITH_CONTENT';
export const PREMIUM_WITH_CONTENT = 'PREMIUM_WITH_CONTENT';

export const contentTierTypes = [GROWTH_WITH_CONTENT, PREMIUM_WITH_CONTENT];
